export const DEFAULT_TAB = 'Overview';
export const HOST_DETAILS_KEY = 'HOST_DETAILS';
export const HOST_DETAILS_API_OPTIONS = { key: HOST_DETAILS_KEY };
export const TABS_SLOT_ID = 'host-details-page-tabs';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/HostDetails/consts.js